export default "__VITE_ASSET__C6rWtZ8I__"